import { render, staticRenderFns } from "./DataTableAcuerdosClientes.vue?vue&type=template&id=35d37ba0&scoped=true"
import script from "./DataTableAcuerdosClientes.vue?vue&type=script&lang=js"
export * from "./DataTableAcuerdosClientes.vue?vue&type=script&lang=js"
import style0 from "./DataTableAcuerdosClientes.vue?vue&type=style&index=0&id=35d37ba0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d37ba0",
  null
  
)

export default component.exports